import { createElement } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { OutboundCampaigns } from './campaigns/campaigns';
import { OutboundCampaignDetails } from './campaigns/campaign-details';
import { OutboundScenarios } from './scenarios/scenarios';
import { OutboundCallsHistory } from './calls/calls-history';
import { Salespeople } from './salespeople/salespeople';

export const OUTBOUND_TABS = ['campaigns', 'scenarios', 'calls', 'salespeople'] as const;

export type OutboundTab = (typeof OUTBOUND_TABS)[number];

/**
 * Children of `/outbound-calls`, rendered in the shell's Outlet. Kept in a .ts file because a
 * .tsx exporting route objects would break fast refresh.
 */
export const OUTBOUND_CALLS_ROUTES: RouteObject[] = [
  { index: true, element: createElement(Navigate, { to: 'campaigns', replace: true }) },
  { path: 'campaigns', element: createElement(OutboundCampaigns) },
  { path: 'campaigns/:campaignId', element: createElement(OutboundCampaignDetails) },
  { path: 'scenarios', element: createElement(OutboundScenarios) },
  { path: 'calls', element: createElement(OutboundCallsHistory) },
  { path: 'salespeople', element: createElement(Salespeople) },
];
